import { DIVISION } from '@/types/league';

export const convertNumberToDivision = (division: DIVISION): string => {
  switch (division) {
    case 1:
      return 'Public';
    case 2:
      return 'Intermediate';
    case 3:
      return 'Masters';
    case 4:
      return 'Challenger';
    default:
      return 'Unknown';
  }
};
